import { ChangeEvent, type MutableRefObject, useRef } from "react"

import { buildCssClassName } from "@/3514/utils"
import { type TUseAccessibleItemActions, useAccessibleItemActions } from "@/hooks"

import "./styles.scss"

type Props = {
    checked: boolean
    label?: string
    placeholder?: string
    name?: string
    checkMarkVariant?: "default" | "full-fill"
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

const Checkbox = ({ checked, label, placeholder, name, checkMarkVariant = "default", onChange }: Props) => {
    const checkBoxVariants = {
        default: "default",
        "full-fill": "full-fill"
    }

    const ref: MutableRefObject<HTMLInputElement> = useRef<HTMLInputElement>(null)

    const { handleKeyDown, handleClick }: TUseAccessibleItemActions = useAccessibleItemActions.call({
        cb: (): void => ((ref.current.checked = !ref?.current.checked), void 0)
    })

    return (
        <div className="d-flex align-items-center justify-content-center">
            <div className="checkbox-custom" onClick={handleClick}>
                <label className="d-none" htmlFor={name}>
                    {name}
                </label>
                <input
                    ref={ref}
                    id={name}
                    type="checkbox"
                    aria-label={placeholder}
                    checked={checked}
                    onChange={onChange}
                    name={name}
                    placeholder={placeholder}
                />
                <span
                    tabIndex={0}
                    onKeyDown={handleKeyDown}
                    className={buildCssClassName("checkbox-custom__checkmark", checkBoxVariants[checkMarkVariant])}
                />
            </div>
            {label && <p className="checkbox-custom__label color-gray">{label}</p>}
        </div>
    )
}

export default Checkbox
